import React from 'react';

import EditLayerContainer from './EditLayerContainer';

export function EditLayer() {
  return <EditLayerContainer />;
};

export default EditLayer;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/index.js